var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3 mt-5"},[_c('b-container',[_c('h1',{staticClass:"text-primary font-weight-bold text-center mb-5"},[_vm._v(_vm._s(_vm.$t('password_reset.title')))]),_c('password-reset-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }